/* One product per design means Item / Colour / Size combinations that do not
   exist (Poster + XS). Horizon strikes those pills through and turns the
   add-to-cart button into "Unavailable"; it does not move the selection.
   This does: whenever a checked pill is marked unavailable, pick the first
   pill in that row that is, so the buy row is always live. */
(function () {
  var PICKER = "variant-picker";
  var SETTLE_MS = 60;           // the theme morphs the picker after each change
  var timer = null;

  function repair() {
    var picker = document.querySelector(PICKER);
    if (!picker) { return; }
    var rows = picker.querySelectorAll("fieldset");
    for (var i = 0; i < rows.length; i++) {
      var checked = rows[i].querySelector("input:checked");
      if (!checked || checked.dataset.optionAvailable !== "false") { continue; }
      var live = rows[i].querySelector('input[data-option-available="true"]');
      if (!live) { continue; }
      live.click();                // the theme's own handler re-renders from here
      return;                      // one row per pass; the observer brings us back
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(repair, SETTLE_MS);
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true, attributeFilter: ["data-option-available", "checked"]
  });
  document.addEventListener("change", schedule, true);
  schedule();
})();
